/**
 * Shared editor SX:
 *  - Removes MUI's outlined border in normal and focused states so the cell
 *    keeps a flat look while editing (no blue ring around the input).
 *  - Leaves padding/typography alone so MUI's keyboard nav and accessibility
 *    behaviour stays intact.
 */
export const editorSx = {
	'& .MuiOutlinedInput-notchedOutline': { border: 'none' },
	'& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { border: 'none' },
	'& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { border: 'none' },
	'& .MuiInput-underline:before, & .MuiInput-underline:after, & .MuiInput-underline:hover:not(.Mui-disabled):before': {
		borderBottom: 'none',
	},
} as const
